<template>
  <h2 class="listing-title">
    {{ title }}
    <span v-if="selectedKeywordAndFilters" class="app--hidden app--mobile-shown--inline-block">
      :
    </span>
    <span class="app--hidden app--mobile-shown--inline-block" v-if="selectedKeywordAndFilters">
      {{ selectedKeywordAndFilters }}
      <ButtonReset @click="$emit('reset-click')" color="#3596F4" font-size="12px"></ButtonReset>
    </span>
  </h2>
</template>

<script>
import { ButtonReset } from '@/components/button';

export default {
  props: ['selectedKeywordAndFilters', 'title'],
  components: {
    ButtonReset,
  },
};
</script>

<style lang="scss">
.listing-title {
  font-weight: 400;
  margin-bottom: 1rem;
  color: #174169;
  font-size: 18px;
}
</style>
